export const fieldClass =
  'w-full rounded-xl border border-slate-800 bg-slate-950/80 px-3 py-2 text-sm text-slate-100 outline-none placeholder:text-slate-600 focus:border-slate-500';

export const cardClass = 'rounded-2xl border border-slate-800 bg-slate-900/60 backdrop-blur-md';

export function notify(message: string, tone: 'ok' | 'error' = 'ok') {
  window.dispatchEvent(new CustomEvent('platform-toast', { detail: { message, tone } }));
}
